var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_2958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2463 19.301V13.652L72.7919 17.9224C74.7125 19.4208 75.0767 21.6017 75.0318 21.5471C73.7814 20.0013 72.1116 19.3229 70.962 19.3048L67.2463 19.301Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1883 20.5201H78.0388V35.461H82.1883V20.5201Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4632 13.4666H85.3137V35.4612H89.4632V13.4666Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.735 13.4666H92.5855V35.4612H96.735V13.4666Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8786 30.2996C70.8786 30.9651 70.2985 31.5114 69.6427 31.5114H66.1009V24.3999H69.6427C70.3026 24.3999 70.8786 24.9398 70.8786 25.6117V30.2996ZM66.1285 20.525V13.4755H62V35.459H70.6397C73.0703 35.459 75.0394 33.4015 75.0394 30.8619V25.122C75.0394 22.5825 73.0703 20.525 70.6397 20.525H66.1285Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0884 18.395C81.5856 18.395 82.7992 17.1873 82.7992 15.6975C82.7992 14.2077 81.5856 13 80.0884 13C78.5913 13 77.3777 14.2077 77.3777 15.6975C77.3777 17.1873 78.5913 18.395 80.0884 18.395Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_2958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 23,
    fill: "white",
    transform: "translate(62 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.af25ef4e57c17bd4832c587581506e65.svg";
export { ForwardRef as ReactComponent };